import { Component, OnInit, Input, ViewChild, OnDestroy, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { UIChart } from 'primeng/chart';

import ChartDataLabels from 'chartjs-plugin-datalabels';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { ReportsService } from '../../../../data/reports.service';
import { LocalStorage } from 'ngx-webstorage';
import { Subject, Subscription, timer } from 'rxjs';
import { debounceTime, skip } from 'rxjs/operators';
import { LineChartQuery } from '../../../../data/line-chart.query';
import { takeUntil } from 'rxjs/operators';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { GraphData } from '../../../../data/graph-data';


@Component({
    selector: 'app-doughnut-chart',
    templateUrl: './doughnut-chart.component.html',
    styleUrls: ['./doughnut-chart.component.scss']
})
@RxJSUnsubscribe
export class DoughnutChartComponent implements OnInit, AfterViewInit, OnDestroy, RxJSUnsubscribable {

    @Input()
    basicData: GraphData = {};

    @Input()
    basicOptions: any;

    @ViewChild('doughChart', { static: true })
    uiChart: UIChart;

    tempUserMap = new Map();

    @Output()
    chartLoaded = new EventEmitter<void>();

    updateSubj: Subscription;

    @LocalStorage()
    hiddenUsersIds: number[]

    chartLoadingSubj: Subscription;

    graphLoading = true;

    totalInfo = 0;

    constructor(
        protected reportsService: ReportsService,
        protected lineChartQuery: LineChartQuery
    ) { }

    ngOnInit(): void {
        this.uiChart.plugins.push(ChartDataLabels)

        this.basicData.datasets[0].userId.forEach((id, index) => {
            this.tempUserMap.set(id, {
                data: this.basicData.datasets[0].data[index],
                backgroundColor: this.basicData.datasets[0].backgroundColor[index],
                hoverBackgroundColor: this.basicData.datasets[0].hoverBackgroundColor[index],
                label: this.basicData.labels[index],
                index
            })

        })

        this.chartLoadingSubj = this.lineChartQuery.chartLoading$.subscribe(status => this.graphLoading = status)

        this.userFilterSub();

    }

    ngAfterViewInit() {
        this.chartLoaded.emit();
        this.updateInfo();
        this.countTotal();
    }

    userFilterSub() {
        this.updateSubj = this.reportsService.userFilter$.pipe(
            // skip(1),
            debounceTime(1),
            takeUntil(this.getUnsubFromAllSubs())
        ).subscribe(userId => {
            this.filterData(userId)
        })

    }

    filterData(userId: number) {

        if (this.basicData.datasets) {
            const i = this.basicData.datasets[0].userId.findIndex(id => id === userId);

            if (this.basicData.datasets) {

                if (i >= 0) {
                    this.basicData.datasets[0].userId.splice(i, 1)
                    this.basicData.datasets[0].data.splice(i, 1)
                    this.basicData.datasets[0].backgroundColor.splice(i, 1)
                    this.basicData.datasets[0].hoverBackgroundColor.splice(i, 1)
                    this.basicData.labels.splice(i, 1)

                }
                else {
                    if (this.tempUserMap.has(userId)) {
                        const tempUser = this.tempUserMap.get(userId);

                        this.basicData.datasets[0].userId.splice(tempUser.index, 0, userId)
                        this.basicData.datasets[0].data.splice(tempUser.index, 0, tempUser.data)
                        this.basicData.datasets[0].backgroundColor.splice(tempUser.index, 0, tempUser.backgroundColor)
                        this.basicData.datasets[0].hoverBackgroundColor.splice(tempUser.index, 0, tempUser.hoverBackgroundColor)
                        this.basicData.labels.splice(tempUser.index, 0, tempUser.label)
                    }
                }
            }
            if (this.uiChart) {
                this.countTotal();
                this.uiChart.reinit();
            }
        }
    }

    countTotal() {
        this.totalInfo = 0;

        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < this.basicData.datasets[0].data.length; i++) {
            this.totalInfo += this.basicData.datasets[0].data[i]
        }
    }

    updateInfo() {
        if (this.hiddenUsersIds) {
            this.hiddenUsersIds.forEach(id => {
                this.filterData(id)
            })
        }
    }

    ngOnDestroy() {
        this.updateSubj.unsubscribe()
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}
